module.exports = __webpack_public_path__ + "static/img/payments-icon.e77ef49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments-icon.png
// module id = 2316
// module chunks = 48